import React from 'react';
import ExportPage from './export/ExportPage';

const PurchaseExport: React.FC = () => <ExportPage area="purchases" />;

export default PurchaseExport;
